import { NewJourneyNotificationModalTranslations } from "./new-journey-notification-modal-pt-br";

export const NEW_JOURNEY_NOTIFICATION_MODAL_ES_MX: NewJourneyNotificationModalTranslations = {
	title: "Tu jornada de retiro quedó más simple",
	content:
		'Zig unificó las jornadas de retiro y anticipación en un único flujo, brindando más agilidad a quienes necesitan acceder a los recursos de la operación. Haz clic en "Ver Billetera" y prueba la nueva jornada.',
	primaryActionLabel: "Cerrar",
};
